import React from 'react'
import {
  Edit,
  Create,
  DisabledInput,
  TextInput,
  SimpleForm,
  EditButton,
  DeleteButton,
  ImageField,
  List,
  Datagrid,
  TextField,
  ImageInput
} from 'admin-on-rest'
import { requireValidation } from './utils/validation'
import { ImageFieldOrNull, format, fixIfEmptyArray } from './common'

export const OfferList = (props) => (
  <List {...props} sort={{ field: '_id', order: 'DESC' }} perPage={40}>
    <Datagrid bodyOptions={{ stripedRows: true, showRowHover: true }}>
      <ImageField source="smallIcon" sortable={false} label="Small Icon" />
      <ImageField source="productIcon" sortable={false} label="Product Icon" />
      <TextField source="title" label="Title" />
      <TextField source="description" label="Description" />
      <ImageField source="titleBackground" sortable={false} label="Title Background" />
      <EditButton />
      <DeleteButton />
    </Datagrid>
  </List>
)

const OfferTitle = ({ record }) => {
  return <span>Offer {record ? `"${record.title}"` : ''}</span>
}

export const OfferEdit = (props) => (
  <Edit title={<OfferTitle />} {...props}>
    <SimpleForm>
      <DisabledInput source="id" />
      <ImageField source="smallIcon"/>
      <ImageInput source="smallIcon" accept="image/*" format={format} validate={fixIfEmptyArray}>
        <ImageFieldOrNull source="src" />
      </ImageInput>
      <ImageField source="productIcon"/>
      <ImageInput source="productIcon" accept="image/*" format={format} validate={fixIfEmptyArray}>
        <ImageFieldOrNull source="src" />
      </ImageInput>
      <DisabledInput source="title" label="Title" />
      <TextInput source="description" options={{ fullWidth: true }} />
      <ImageField source="titleBackground" />
      <ImageInput source="titleBackground" accept="image/*" format={format} validate={fixIfEmptyArray}>
        <ImageFieldOrNull source="src" />
      </ImageInput>
    </SimpleForm>
  </Edit>
)

export const OfferCreate = (props) => (
  <Create {...props}>
    <SimpleForm>
      <ImageInput source="smallIcon" accept="image/*" format={format} validate={fixIfEmptyArray}>
        <ImageFieldOrNull source="src" />
      </ImageInput>
      <ImageInput source="productIcon" accept="image/*" format={format} validate={fixIfEmptyArray}>
        <ImageFieldOrNull source="src" />
      </ImageInput>
      <TextInput source="title" label="Title" validate={requireValidation} />
      <TextInput source="description" label="Description" />
      <ImageInput source="titleBackground" accept="image/*" format={format} validate={fixIfEmptyArray}>
        <ImageFieldOrNull source="src" />
      </ImageInput>
    </SimpleForm>
  </Create>
)



// WEBPACK FOOTER //
// ./src/offers.js